import React, { useEffect, useContext } from "react";
import { Container, Typography } from "@mui/material";

import { AppContext } from "../Store";
import ChildImageGrid from "./ChildImageGrid";
import * as stubs from "./stubs";

process.env.USE_STUBS;

const ParentsPortal: React.FC = () => {


  const context = useContext(AppContext);
  const { childrenData, loading } = context;
  console.log("pp:chd", { childrenData });


  useEffect(() => { }, []);

  return (
    <Container
      maxWidth="lg"
      style={{
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >

      {childrenData && (
        <ChildImageGrid data={childrenData} />
      )}

      {!childrenData && !loading && (
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          No children assigned to user. Please contact your child's teacher to get access.
        </Typography>
      )}

    </Container>
  );
};

export default ParentsPortal;
